import { PureComponent } from 'react'
import PropTypes from 'prop-types'
import InfiniteScroll from 'react-infinite-scroller'

import { i18n } from '../../i18n'
import { fetchPerformances } from '../../api/performances'
import { fetchArtists } from '../../api/artists'
import { fetchPlaces } from '../../api/places'
import { fetchPodcasts } from '../../api/podcasts'

import Loading from '../Loading'
import GridItem from '../GridItem'
import { Container } from './styles'

class Grid extends PureComponent {
  static propTypes = {
    onChange: PropTypes.func,
    onStarPress: PropTypes.func,
    showStar: PropTypes.bool,
    entity: PropTypes.string.isRequired,
    filters: PropTypes.instanceOf(Object),
    token: PropTypes.string,
    GridItemComponent: PropTypes.func,
    className: PropTypes.string
  }

  static defaultProps = {
    onChange: () => {},
    onStarPress: () => {},
    showStar: false,
    filters: {},
    token: null,
    GridItemComponent: undefined,
    className: undefined
  }

  state = {
    hasMore: true,
    items: []
  }

  constructor() {
    super()
    this.page = 0
    this.isFetching = false
  }

  componentDidUpdate(prevProps) {
    const { filters, entity } = this.props
    if (JSON.stringify(filters) !== JSON.stringify(prevProps.filters) || entity !== prevProps.entity) {
      this.clearData()
    }
  }

  clearData = () => {
    this.page = 0
    this.setState({ items: [], hasMore: true })
  }

  getData = async () => {
    this.isFetching = true

    try {
      const { entity, filters, token } = this.props

      if (this.next !== undefined && this.next === null && this.page > 0) {
        this.isFetching = false
        return
      }

      let fetchEntity
      switch (entity) {
        case 'places':
          fetchEntity = fetchPlaces
          break
        case 'all-artists':
          fetchEntity = fetchArtists
          break
        case 'podcasts':
          fetchEntity = fetchPodcasts
          break
        case 'performances':
        case 'artists':
          fetchEntity = fetchPerformances
          break
      }

      const response = await fetchEntity(this.page, filters, undefined, i18n.language, token || undefined)

      if (!response || !response.results) {
        console.warn(JSON.stringify(response))
        this.isFetching = false
        return
      }

      this.page += 1
      this.isFetching = false
      this.next = response.next

      this.setState(prevState => ({
        items: this.page === 1 ? [...response.results] : [...prevState.items, ...response.results],
        hasMore: response.next !== null
      }))
    } catch (error) {
      console.error(error.toString())
      this.isFetching = false
    }
  }

  loadMore = () => {
    if (!this.isFetching) {
      this.getData()
    } else {
      if (!this.try) {
        this.try = 1
      } else {
        this.try += 1
      }
      if (this.try > 15) return
      setTimeout(() => this.loadMore(), 100)
    }
  }

  selectItem = (selectedValue) => {
    this.props.onChange(selectedValue)
  }

  setStar = (itemId, value) => {
    const { items } = this.state
    items[items.findIndex(item => item.id === itemId)].favorited = value
    // this.setState({ items: [] }, () => {
      this.setState({ items })
    // })
  }

  render() {
    const {
      showStar, onStarPress, GridItemComponent, className
    } = this.props
    const { items, hasMore } = this.state

    return (
      <Container
        style={{
          marginBottom: items.length > 0 ? '50px' : '150px'
        }}
      >
        <InfiniteScroll
          className={`infiniteScroll ${className}`}
          pageStart={0}
          loadMore={this.loadMore}
          hasMore={hasMore}
          useWindow={false}
          getScrollParent={() => document.getElementById('sidebarContent')}
          loader={<Loading key={0} />}
        >
          {items.map(item => (
            <GridItem
              key={item.id}
              item={item}
              onStarPress={onStarPress}
              showStar={showStar}
              GridItemComponent={GridItemComponent}
            />
          ))}
        </InfiniteScroll>
      </Container>
    )
  }
}

export default Grid
